import script from "./DisdiMaintenance.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisdiMaintenance.vue?vue&type=script&setup=true&lang=ts"

import "./DisdiMaintenance.vue?vue&type=style&index=0&id=c25074ea&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c25074ea"]])

export default __exports__